"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isValidUSPhone = void 0;
const regex_1 = require("../../constants/regex");
const us_area_codes_1 = require("../../constants/us-area-codes");
const is_array_1 = require("../is-array/is-array");
const is_string_1 = require("../is-string/is-string");
/**
 * Returns true if the area code is valid in the US
 *
 * @param arg - A phone number string
 * @param enable800 - A boolean flag to allow {@link TOLL_FREE_CODES | toll-free area codes}
 *
 * @returns A boolean indicating whether the phone has a valid area code or not.
 *
 * @internal
 *
 * @example
 * ```ts
 * const result = isValidUSPhoneAreaCode('(219) 336-0666');
 * console.log(result);
 * // -> true
 * ```
 **/
function isValidUSPhoneAreaCode(arg, enable800 = false) {
    const areaCode = +arg.replace(/\D/g, '').substring(0, 3);
    const areaCodes = us_area_codes_1.US_AREA_CODES.slice(0);
    if (enable800) {
        areaCodes.push(...us_area_codes_1.TOLL_FREE_CODES);
    }
    return areaCodes.indexOf(areaCode) >= 0;
}
/**
 * Checks if the provided phone appears in the list of
 * banned phone numbers provided.
 *
 * @param arg - A string phone number
 * @param bannedPhones - An optional list of banned phones
 *
 * @returns A boolean indicating whether the phone is banned or not.
 *
 * @internal
 *
 * @example
 * ```ts
 * const result = isBannedPhone('(219) 336-0666', ['2193360666']);
 * console.log(result);
 * // -> true
 * ```
 */
function isBannedPhone(arg, bannedPhones) {
    return ((0, is_array_1.isArray)(bannedPhones) &&
        bannedPhones.some((banned) => banned.replace(/\D/g, '') === arg.replace(/\D/g, '')));
}
/**
 * Returns true if the string is a valid US phone
 * @public
 *
 * @param arg - A generic argument to check.
 * @param config - Config flags to modify the validation logic.
 *
 * @returns A boolean indicating whether the input is a valid US phone or not.
 *
 * @example
 * ```ts
 * const result = isValidUSPhone('(219) 336-0666');
 * console.log(result);
 * // -> true
 * ```
 *
 * @see https://developers.google.com/style/phone-numbers
 **/
function isValidUSPhone(arg, config) {
    return ((0, is_string_1.isString)(arg) &&
        regex_1.US_PHONE.test(arg) &&
        isValidUSPhoneAreaCode(arg, config === null || config === void 0 ? void 0 : config.enable800) &&
        !isBannedPhone(arg, config === null || config === void 0 ? void 0 : config.bannedPhones));
}
exports.isValidUSPhone = isValidUSPhone;
//# sourceMappingURL=is-valid-us-phone.js.map